const translations = {
    cancel: 'Cancel',
    email: 'Email',
    firstName: 'First Name',
    lastName: 'Last Name',
    phone: 'Phone',
    save: 'Save',
    saveError: 'Your details could not be saved.',
    saving: 'Saving…',
    title: 'Edit My Information'
};

export default translations;
